import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { EnumFiltroFechas } from "src/app/enums/FiltroFechas.enum";
import { SemanaService } from "src/app/services/Semana.service";
@Component({
    selector: 'filtro-fecha-inteligente',
    templateUrl: './filtroFecha.component.html',
    styleUrls: ['./filtroFecha.component.scss'],
    encapsulation: ViewEncapsulation.None
  })
export class FiltroFechaInteligenteComponent {
    @Input() filtro         : Number;
    @Input() fechaIniISO    : string;
    @Input() fechaFinISO    : string;
    @Input() Etiqueta       : string;
    @Input() inline         : boolean = false;
    @Output() FechaSeleccionada = new EventEmitter<any>();

    public maxDate      : Date = new Date(new Date().toISOString().slice(0,10)+'T'+new Date().getHours()+':'+new Date().getMinutes()+':'+new Date().getSeconds());
    public dateFechaIni : FormControl;
    public dateFechaFin : FormControl;
    public fechaSel     : Number = EnumFiltroFechas.SEMANA_ACTUAL ;
    public isCustom     : Boolean = false;
    public filtroFecha = [
        { name: "Semana Actual"     , value: EnumFiltroFechas.SEMANA_ACTUAL     },
        { name: "Semana Anterior"   , value: EnumFiltroFechas.SEMANA_ANTERIOR   },
        { name: "Hoy"               , value: EnumFiltroFechas.HOY               },
        { name: "Mes Actual"        , value: EnumFiltroFechas.MES_ACTUAL        },
        { name: "Mes Anterior"      , value: EnumFiltroFechas.MES_ANTERIOR      },
        { name: "Rango de Fechas"   , value: EnumFiltroFechas.RANGO_DE_FECHAS   },
    ]
    constructor(
        private SemanaSvc: SemanaService,
    ) {}
    ngOnInit() {
        this.fechaSel       = this.filtroFecha.find( e => e.value == this.filtro ).value;
        this.dateFechaIni   = new FormControl(this.fechaIniISO);
        this.dateFechaFin   = new FormControl(this.fechaFinISO);
    }
    ngAfterViewInit(): void {
        this.FechaPersonalizada();
        this.GetFiltroFecha();
    }
    addDate(ctrl: string, event: MatDatepickerInputEvent<Date>) {
        if (!event.value) return;
        switch (ctrl) {
            case "Inicial":
                this.fechaIniISO = event.value.toISOString().slice(0,10)+"T00:00:00";
                break;
            case "Final":
                this.fechaFinISO = event.value.toISOString().slice(0,10)+"T23:59:59";
                break;
            default:
                break;
        }
        this.FechaSeleccionada.emit({ fechaSel     :this.fechaSel, dateFechaIni :this.fechaIniISO, dateFechaFin :this.fechaFinISO });
    }
    // public GetMonday( dias : number): Date {
    //     let d       = new Date();
    //     let dow     = d.getDay();
    //     let diff    = d.getDate() - dow ;
    //     // if( dias == 0 ) diff = diff + 5 ;
    //     if( dias == 0 ) diff = diff + 7 ;
    //     d.setDate( diff - dias );
    //     return new Date( d );
    // }
    public GetFiltroFecha() {
        if (this.fechaSel != EnumFiltroFechas.RANGO_DE_FECHAS) {
            this.isCustom = false;            
            switch (this.fechaSel) {
                case EnumFiltroFechas.MES_ANTERIOR:
                    this.fechaIniISO = new Date(new Date().getFullYear(), new Date().getMonth()-1).toISOString().slice(0,10)+"T00:00:00";
                    this.fechaFinISO = new Date(new Date().getFullYear(), new Date().getMonth(),0).toISOString().slice(0,10)+"T23:59:59";
                    break;

                case EnumFiltroFechas.SEMANA_ANTERIOR:
                    this.fechaIniISO = this.SemanaSvc.GetFecha('inicial',7);
                    this.fechaFinISO = this.SemanaSvc.GetFecha('final',1);
                    break;

                case EnumFiltroFechas.HOY:
                    this.fechaIniISO = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString().slice(0,10)+"T00:00:00";
                    this.fechaFinISO = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString().slice(0,10)+"T23:59:59";
                    break;

                case EnumFiltroFechas.SEMANA_ACTUAL:
                    this.fechaIniISO = this.SemanaSvc.GetFechaInicial();
                    this.fechaFinISO = this.SemanaSvc.GetFechaFinal();                     
                    break;

                case EnumFiltroFechas.MES_ACTUAL:
                    this.fechaIniISO = new Date(new Date().getFullYear(), new Date().getMonth(),1).toISOString().slice(0,10)+"T00:00:00";
                    this.fechaFinISO = new Date(new Date().getFullYear(), new Date().getMonth()+1,0).toISOString().slice(0,10)+"T23:59:59";
                    break;
            }
        }else{
            this.isCustom = true;
        }
        this.dateFechaIni = new FormControl(this.fechaIniISO);
        this.dateFechaFin = new FormControl(this.fechaFinISO);
        this.FechaSeleccionada.emit({ fechaSel     :this.fechaSel, dateFechaIni :this.fechaIniISO, dateFechaFin :this.fechaFinISO });
    }
    public FechaPersonalizada() {
        this.isCustom = this.fechaSel === EnumFiltroFechas.RANGO_DE_FECHAS;
    }
}